import { CnLayoutPage } from '@cainiaofe/cn-ui-layout';
export { CnLayoutPage, CnLayoutHeader, CnLayoutNav, CnLayoutAside, CnLayoutContent, CnLayoutFooter, CnLayoutSection, CnLayoutBlock, CnLayoutGrid, CnLayoutRow, CnLayoutCol, CnLayoutCell, CnLayoutFixedPoint, CnLayoutFixedContainer, CnLayoutSpace, } from '@cainiaofe/cn-ui-layout';
export default CnLayoutPage;
